// lazyload
$(function() {
  var $lazyloadobj = $('img.lazyload');
  if ($lazyloadobj.length) {
    console.log('$lazyloadobj is exist');
    $lazyloadobj.lazyload();
  }
});
